module.exports = __webpack_public_path__ + "media/images/logo-small-75d0ec7d3fa02c5fa443d6fc22af0154.png";